module.exports = __webpack_public_path__ + "static/media/Apurva_Haspe.f6a4740f.jpg";